module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/material-icon/MaterialIcons-Regular.ttf
// module id = ../../../../../src/assets/material-icon/MaterialIcons-Regular.ttf
// module chunks = styles